/**
 * Ryan O'Dowd
 * 2024-02-20
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import ContinueReading from './ContinueReading';
import DailyGoals from './DailyGoals';
import Friends from './Friends';
import Help from './Help';
import PassageOfTheDay from './PassageOfTheDay';
import RecentGoals from './RecentGoals';
import StormForecast from './StormForecast';
import WrinkleRefresh from './WrinkleRefresh';

const Widgets = {
  ContinueReading,
  DailyGoals,
  Friends,
  Help,
  PassageOfTheDay,
  RecentGoals,
  StormForecast,
  WrinkleRefresh,
};

export default Widgets;
